<template>
  <v-breadcrumbs
    v-if="hasBreadcrumbs"
    divider="/"
    :items="breadcrumbs"
    class="breadcrumb"
  >
    <template v-slot:item="props">
      <v-breadcrumbs-item
        :to="props.item.link"
        active-class=""
        :class="[props.item.disabled && 'disabled']"
      >
        {{ computeText(props.item) }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import i18n from '@/utils/i18n'
export default {
  data() {
    return {
      breadcrumbs: [],
    }
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbs.length > 1
    },
  },
  watch: {
    $route(to) {
      var rawBread = []
      if (to.meta.breadcrumb) {
        rawBread = to.meta.breadcrumb(to)
      }
      this.breadcrumbs = rawBread.map((b, i) => {
        return {
          code: b.code,
          link: b.link,
          disabled: i < rawBread.length - 1,
        }
      })
    },
  },
  methods: {
    computeText(b) {
      return i18n.t(b.code)
    },
  },
}
</script>

<style scoped>
.v-breadcrumbs {
  background-color: var(--v-filArianeBg-base);
}

.v-breadcrumbs.breadcrumb {
  padding: 9px;
}
</style>
